import { useState } from "react";
import classNames from "classnames";
import styles from "./AscRangeInput.module.scss";

export interface AscRangeInputProps {
  max?: number;
  onChange: (rate: number) => void;
  className?: string;
  defaultValue?: number;
}

const rangeLevels = [
  { value: "1", label: "Strongly disagree" },
  { value: "2", label: "Disagree" },
  { value: "3", label: "Neutral" },
  { value: "4", label: "Agree" },
  { value: "5", label: "Strongly agree" },
];

export default function AscRangeInput({
  max = 10,
  onChange,
  className,
  defaultValue = 1,
}: AscRangeInputProps) {
  const [rate, setRate] = useState(defaultValue);

  const handleRate = (rate: number) => {
    setRate(rate);
    if (onChange) {
      onChange(rate);
    }
  };

  return (
    <div
      data-testid="asc-range-input"
      className={classNames(styles.rangeWrapper, className)}
    >
      <div className={classNames(styles.range, styles.rangeStep)}>
        <ul className={styles.rangeLevelList}>
          {rangeLevels.map((el) => (
            <li
              key={el.value}
              value={el.value}
              className={styles.rangeLevel}
            >
              {el.label}
            </li>
          ))}
        </ul>
        <input
          value={rate}
          type="range"
          max={max}
          min={1}
          step={1}
          className={classNames(styles.rangeInput, {
            [styles[`rangeInput` + rate]]: true,
          })}
          style={{width: `${100 - 100 / max}%`, marginLeft: `${100 / max}%`}}
          onChange={(e) => {
            handleRate(+e.target.value);
          }}
        />
        <div className={styles.rangeOptionList}>
          {Array.from(Array(max).keys(), (n) => n + 1).map((el) => (
            <div
              key={el}
              className={classNames(
                styles.rangeOption,
                +el <= +rate && styles.rangeOptionSelected,
                +el === +rate && styles.rangeOptionLast
              )}
            >
              {el}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
